import { NgModule } from '@angular/core';
import { ASM_CUSTOMER_360_FEATURE, AsmCustomer360RootModule } from '@spartacus/asm/customer-360/root';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [AsmCustomer360RootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [ASM_CUSTOMER_360_FEATURE]: {
          module: () => import('@spartacus/asm/customer-360').then((m) => m.AsmCustomer360Module),
        },
      },
    }),
  ],
})
export class AsmCustomer360FeatureModule {}
